<div class="content">
    <div class="header">
        <div>
            <p>Shop by movement</p>
            <h2>Find your set for the way you move.</h2>
        </div>
        <a routerLink="/search" aria-label="All Products">Shop All
            <mat-icon fontSet="material-symbols-outlined" inline>arrow_forward</mat-icon>
        </a>
    </div>

    <div class="categories">

        @for (c of tags; track $index) {
        <a class="category" showdown [showDelay]="50+100*$index" routerLink="/search" [queryParams]="{tags:[c.name]}"
            aria-label="{{c.name}} activewear products">
            <img [ngSrc]="c.image" fill [alt]="c.name + ' activewear category'">
            <span>{{c.description}}</span>
            <h3>{{c.name}}</h3>
        </a>
        }

    </div>
</div>